import {
  ContainerDate,
  DateText,
  BoxDate,
  LetterThin
} from './DatePromo.styles';

interface DataPromoInterface {
  startData?: string;
  endData?: string;
}

export default function DatePromo({ startData, endData }: DataPromoInterface) {

  return (
    <BoxDate>
      <h5>Vigência da Promoção</h5>
      <ContainerDate>
        <DateText><span>{startData ? `${startData.slice(6, 8)}/${startData.slice(4, 6)}/${startData.slice(0, 4)}` : ''} <LetterThin>à</LetterThin> {endData ? `${endData.slice(6, 8)}/${endData.slice(4, 6)}/${endData.slice(0, 4)}` : ''}</span></DateText>
      </ContainerDate>
    </BoxDate>
  );
}

